module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8458/img/blobsLeft.png"